import React, { useState, useEffect } from "react";
import { ArrowDown, ArrowUp, ArrowDownBlue, ArrowUpBlue } from "../assets/icons";

const SortArrows = ({ sortOrder, order = () => {} }) => {
   const [currentOrder, setCurrentOrder] = useState(sortOrder.sortOrder);

   useEffect(() => {
      setCurrentOrder(sortOrder.sortOrder);
   }, [sortOrder.sortOrder]);

   const handleClick = () => {
      const newOrder = currentOrder === "ascend" ? "descend" : "ascend";
      setCurrentOrder(newOrder);
      order(newOrder);
   };

   return (
      <span
         style={{
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            gap: "4px"
         }}
         onClick={handleClick}
      >
         <img src={currentOrder === "ascend" ? ArrowUpBlue : ArrowUp} alt="ArrowUp" />
         <img src={currentOrder === "descend" ? ArrowDownBlue : ArrowDown} alt="ArrowDown" />
      </span>
   );
};

export default SortArrows;
